export default __webpack_public_path__ + "media/images/preview-1f18effa56ea793e2897339774674ac2.png";